// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modifGeneral {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: auto;
  padding-top: 3rem;
  height: 40vh;
}

.modifMail {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 25px 25px 25px;
}

.modifPassword {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 25px 25px 25px;
}

.settingsTitle {
  text-align: center;
}

.settingsPassword {
  display: contents;
}

@media screen and (max-width: 1100px) {
  .modifGeneral {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/UserSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":[".modifGeneral {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin: auto;\n  padding-top: 3rem;\n  height: 40vh;\n}\n\n.modifMail {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 0 25px 25px 25px;\n}\n\n.modifPassword {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 0 25px 25px 25px;\n}\n\n.settingsTitle {\n  text-align: center;\n}\n\n.settingsPassword {\n  display: contents;\n}\n\n@media screen and (max-width: 1100px) {\n  .modifGeneral {\n    flex-wrap: wrap;\n  }\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
